import { render, staticRenderFns } from "./dataDownLoad.vue?vue&type=template&id=ce27e8ec&scoped=true"
import script from "./dataDownLoad.vue?vue&type=script&lang=js"
export * from "./dataDownLoad.vue?vue&type=script&lang=js"
import style0 from "./dataDownLoad.vue?vue&type=style&index=0&id=ce27e8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce27e8ec",
  null
  
)

export default component.exports